<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">List of Reviews</h2>

        <small class="text-muted">Manage all your FFC review here. </small>
      </div>

      <base-button
        outline
        class="px-3 py-1 mx-1"
        type="primary"
        @click="handleOpen"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon> Add
          Review
        </span>
      </base-button>
    </div>
    <ReviewTable ref="dataLoad" />
    <b-modal
      header-bg-variant="primary text-white"
      class="custmodaltitle"
      id="add-review"
      title="Add Brand"
      hide-footer
    >
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <b-form role="form" @submit.prevent="handleSubmit(handleCreate)">
          <div class="mb-4">
            <p class="input-title text-black">
              Heading<span class="clr-red">*</span>
            </p>
            <base-input
              v-model="heading"
              placeholder="Enter review heading"
              class="md:border-0 lg:border-0 custipshadow"
              name="Heading"
              :rules="{ required: true }"
            ></base-input>
          </div>
          <div class="mb-4">
            <p class="input-title text-black">
              Description<span class="clr-red">*</span>
            </p>
            <base-input
              v-model="description"
              placeholder="Enter  review content"
              class="md:border-0 lg:border-0 custipshadow"
              name="Description"
              :rules="{ required: true }"
            ></base-input>
          </div>
          <div class="flex justify-center">
            <b-button
              class="font-semibold"
              type="primary"
              native-type="submit"
              variant="primary"
              >Save</b-button
            >
          </div>
        </b-form>
      </validation-observer>
    </b-modal>
  </b-card>
</template>

<script>
import ReviewTable from "./components/ReviewTable.vue";

export default {
  components: {
    ReviewTable,
  },
  data() {
    return {
      heading: "",
      description: "",
    };
  },
  methods: {
    handleOpen() {
      this.heading = "";
      this.description = "";
      this.$bvModal.show("add-review");
    },
    async handleCreate() {
      let payload = {
        heading: this.heading.trim(),
        description: this.description.trim(),
      };
      let loader = this.$loading();
      try {
        await this.$store.dispatch("ffc/add_review", payload);
        this.$refs.dataLoad.dataLoad();
        this.reset();
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    reset() {
      this.$bvModal.hide("add-review");
      this.name = "";
      this.email = "";
    },
  },
};
</script>
<style>
.modal-title {
  color: white !important;
}
</style>
